import React, {useState, useEffect} from 'react';
import { Input } from 'semantic-ui-react';
import moment from 'moment';
import { useIntl } from "react-intl";

interface SearchInputProps {
 style?: Record<string,any>;
 interval?: number;
 minHour?: number;
 maxHour?: number;
 onTextChange?: () => void;
}

const DEFAULT_PROPS = {
  style: {},
  children: () => {},
  placeholder: 'Choose Time',
  icon: 'clock',
  onTextChange: () => {},
  minHour: 0,
  maxHour: 23,
  interval: 30
}
const SearchInput = (propsParam: SearchInputProps) => {

  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value])=> value !== undefined))
  }
  const intl = useIntl();
  const [timeList, setTimeList] = useState<any[]>([]);

  useEffect(() => {
    generateTimeOptions();
  }, [props.minHour, props.maxHour, props.interval]);

  const generateTimeOptions = () => {

    var min = ":00";
    const date = moment().format("MM/DD/YYYY");

    let timeList: any[] = [];
    let start = moment(date + " " + ("0" + props.minHour).slice(-2) + min, "MM/DD/YYYY HH:mm");

    let end = moment(date + " " + ("0" + props.maxHour).slice(-2) + min, "MM/DD/YYYY HH:mm");
    if (props.maxHour == 23) {
      end = moment(date + " " + ("0" + props.maxHour).slice(-2) + ":59", "MM/DD/YYYY HH:mm");
    }

    while (start <= end) {
      const time = moment(start).format("HH:mm");
      timeList.push(time);
      start = moment(start).add(props.interval, "minutes");
    }
    setTimeList(timeList as any)
  }

  return (
    <div style={{ ...props.style }}>
      <Input
        list='time_datalist_id'
        placeholder={props.placeholder}
        onChange={(e) => {
          props.onTextChange(e.target.value)
        }}
        icon={props.icon}
      />
      <datalist
        id='time_datalist_id'
        // @ts-ignore
        icon='clock'>
        {timeList.map((time, index) => {
          return (<option key={index} value={time} />)
        }
        )}
      </datalist>
    </div>
  )
}

export default SearchInput;